import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetPayAcrossCareLevelsRequestDtoSchema = z.object({
  facilityId: z.number(),
  baseline: z.enum(['MEDIAN', 'AVERAGE']).optional(),
});

const ResidentPayDataDtoSchema = z.object({
  residentId: z.number().nullable(),
  fullName: z.string(),
  payPosition: z.number(),
  rate: z.number(),
});

const PayAcrossCareLevelsResponseDtoSchema = z.object({
  labels: z.array(z.string()),
  data: z.array(z.array(ResidentPayDataDtoSchema)),
});

export type GetPayAcrossCareLevelsRequestDto = z.infer<
  typeof GetPayAcrossCareLevelsRequestDtoSchema
>;
export type ResidentPayDataDto = z.infer<typeof ResidentPayDataDtoSchema>;
export type PayAcrossCareLevelsResponseDto = z.infer<
  typeof PayAcrossCareLevelsResponseDtoSchema
>;

export const getPayAcrossCareLevels = (
  params: GetPayAcrossCareLevelsRequestDto,
  config?: AxiosRequestConfig<GetPayAcrossCareLevelsRequestDto>
) => {
  const validatedParams = GetPayAcrossCareLevelsRequestDtoSchema.parse(params);
  return api
    .get('/residents/pay-across-care-levels', {
      params: validatedParams,
      ...config,
    })
    .then(responseContract(PayAcrossCareLevelsResponseDtoSchema));
};
